import { css } from '@emotion/react'
import { avatarListParts, avatarListRoot } from '@opallabs/lapidary'

export const container = css({
  display: 'inline-flex',
  flexDirection: 'row-reverse',
  blockSize: 'auto',
  inlineSize: 'auto',

  // offsets border of avatar items, otherwise they get clipped in legacy iframes
  [`.${avatarListRoot}`]: {
    padding: 1,

    // Hide the inline label AvatarList renders for a lone user
    [`[part~='${avatarListParts.singleAvatarLabel}']`]: {
      display: 'none',
    },
  },
})
